import { AUTH_API_BASE_URL, ISaveUserRoles, IUserRoles } from '../../shared';
import { AuthClient } from '../../shared/clients/auth.client';

class UserRoleClient extends AuthClient<ISaveUserRoles, IUserRoles> {
    constructor() {
        super(`${AUTH_API_BASE_URL}/v1/acls`);
    }
}

export const userRoleClient = new UserRoleClient();
